export default {
  install(Vue) {
    Vue.prototype.$notify = function ({
      content = "",
      status = null,
      timeout = 3000,
      close = "關閉",
    }) {
      this.$root.$emit("show-snackbar", { content, status, timeout, close });
    };
  },
};
